import { render, staticRenderFns } from "./historicoActividades.vue?vue&type=template&id=3f99ac93"
import script from "./historicoActividades.vue?vue&type=script&lang=js"
export * from "./historicoActividades.vue?vue&type=script&lang=js"
import style0 from "./historicoActividades.vue?vue&type=style&index=0&id=3f99ac93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports